'use client';

import { usePathname } from "next/navigation";
import Image from "next/image";
import styles from "header.module.css"

export default function Header(){
    const pathname = usePathname();
    const isPhotographerPage = pathname?.startsWith("/photographer/");

    return(
        <header>
            <Image
                src="/assets/logo.png"
                width={200}
                height={50}
                alt="Logo de FishEye"
            />
            {!isPhotographerPage && (
                <nav>
                    <a href="#photographers">Nos photographes</a>
                </nav>
            )}
        </header>
    );
}